import {
  collection, addDoc, updateDoc, deleteDoc,
  doc, getDocs, getDoc, query, where, serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { COLLECTIONS } from '../firebase/collections';

// Génère un token unique pour l'URL publique du QR code
function generateQrToken() {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  return Array.from({ length: 20 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
}

export const sectorService = {

  // Créer un secteur
  async createSector({ name, building, floor, schoolId, demandeurId, description = '' }) {
    const qrToken = generateQrToken();
    const docRef = await addDoc(collection(db, COLLECTIONS.SECTORS), {
      name,
      building: building || '',
      floor: floor || '',
      description,
      schoolId,
      demandeurId,
      qrToken,
      active: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return { id: docRef.id, qrToken };
  },

  // Récupérer tous les secteurs d'une école
  async getSectorsBySchool(schoolId) {
    const q = query(
      collection(db, COLLECTIONS.SECTORS),
      where('schoolId', '==', schoolId),
      where('active', '==', true)
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  },

  // Récupérer les secteurs assignés à un demandeur
  async getSectorsByDemandeur(demandeurId) {
    const q = query(
      collection(db, COLLECTIONS.SECTORS),
      where('demandeurId', '==', demandeurId),
      where('active', '==', true)
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  },

  // Récupérer un secteur par son qrToken (accès public)
  async getSectorByToken(qrToken) {
    const q = query(
      collection(db, COLLECTIONS.SECTORS),
      where('qrToken', '==', qrToken),
      where('active', '==', true)
    );
    const snap = await getDocs(q);
    if (snap.empty) return null;
    const d = snap.docs[0];
    return { id: d.id, ...d.data() };
  },

  // Mettre à jour un secteur
  async updateSector(sectorId, updates) {
    await updateDoc(doc(db, COLLECTIONS.SECTORS, sectorId), {
      ...updates,
      updatedAt: serverTimestamp(),
    });
  },

  // Régénérer le QR token (en cas de compromission)
  async regenerateToken(sectorId) {
    const newToken = generateQrToken();
    await updateDoc(doc(db, COLLECTIONS.SECTORS, sectorId), {
      qrToken: newToken,
      updatedAt: serverTimestamp(),
    });
    return newToken;
  },

  // Désactiver un secteur (soft delete)
  async deleteSector(sectorId) {
    await updateDoc(doc(db, COLLECTIONS.SECTORS, sectorId), {
      active: false,
      updatedAt: serverTimestamp(),
    });
  },

  // Récupérer les demandes anonymes en attente de validation pour un demandeur
  async getPendingValidations(demandeurId) {
    const q = query(
      collection(db, COLLECTIONS.WORK_REQUESTS),
      where('assignedDemandeurId', '==', demandeurId),
      where('status', '==', 'pending_validation')
    );
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  },

  async getValidatedByDemandeur(demandeurId) {
    const q = query(
      collection(db, COLLECTIONS.WORK_REQUESTS),
      where('assignedDemandeurId', '==', demandeurId)
    );
    const snap = await getDocs(q);
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .filter(d => d.status !== 'pending_validation');
  },
};
